"use client";

// Balance-scale icon used by the composer Judge button and (decoratively) by
// the toolbar judge button. Mirrors iOS BalanceScaleIcon canvas drawing.
// strokeWidth multiplier: 2.75 (default, prominent) vs 1.6 (composer variant
// — thinner so it reads cleanly against the accent-colored fill).
export default function BalanceScaleIcon({
  size = 14,
  color = "currentColor",
  strokeMultiplier = 2.75,
}: {
  size?: number;
  color?: string;
  strokeMultiplier?: number;
}) {
  // viewBox 24×24 — same units iOS uses. Stroke width scales with the
  // multiplier so the same SVG can render thin (composer) or thick (toolbar).
  const sw = strokeMultiplier;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
      aria-hidden
    >
      <path d="M12 2v20" />
      <path d="M2 7h20" />
      <path d="M5 7l-3 9h8L7 7" />
      <path d="M17 7l-3 9h8L19 7" />
      <path d="M9 22h6" />
      <circle cx="12" cy="2" r="1.5" fill={color} stroke="none" />
    </svg>
  );
}
